export default __webpack_public_path__ + "static/media/power-drill.1829b171.jpg";